import { useMemo } from 'react'
import { RestProperty } from 'data/types/property'
import ServiceSlider from 'components/sections/ServiceSlider'
import { joinBy, propertyPrice } from '@ama-selections/ui'
import { BathroomIcon, BedroomIcon, GuestsIcon } from 'components/icons'

interface OurPropertiesSectionProps {
  properties: RestProperty[]
}

const OurPropertiesSection = ({ properties }: OurPropertiesSectionProps) => {
  const viewAllLink = useMemo(() => {
    if (properties.length === 0) {
      return '/search'
    }

    const property = properties[0]
    return joinBy(
      [property.country.slug, property.region.slug],
      '/',
      { withPrefix: true },
    )
  }, [properties])

  return (
    <ServiceSlider
      className={{
        container: 'my-[75px] lg:my-[165px]',
      }}
      subheading="OUR PROPERTIES"
      heading={'Browse the most\nexclusive holiday\nhomes nearby'}
      description="Discover a definitive collection of the region’s most exclusive holiday homes. Upon booking, our in-house concierge team will assist you in tailoring your stay to create an unforgettable holiday."
      button={{
        href: viewAllLink,
        text: 'View All',
      }}
      items={properties.map(property => ({
        href: `/${property.url}`,
        className: {
          serviceCard: {
            superHeading: 'lg:text-13',
            heading: 'lg:mt-10',
            iconText: 'lg:!text-14',
          },
        },
        superHeading: joinBy([
          property.sub_region?.value,
          property.region?.value,
        ]),
        heading: property.title,
        image: {
          media: property.main_image,
          alt_text: property.main_image_alt_text,
        },
        iconText: [
          {
            count: property.bedrooms,
            base: 'Bedroom',
            icon: <BedroomIcon />,
          },
          {
            count: property.bathrooms,
            base: 'Bathroom',
            icon: <BathroomIcon />,
          },
          {
            count: property.guests,
            base: 'Guest',
            icon: <GuestsIcon />,
          },
        ],
        pillText: [
          propertyPrice(property, true),
        ],
      }))}
    />
  )
}

export default OurPropertiesSection
